import React, { useEffect, useMemo, useRef, useState } from "react";
import "./patient-search.scss";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { dateFormat } from "../../utils/common-funtions/common";
import { getPatients, resetAllPatients } from "../../store/slices/patientSlice";

const SEARCH_KEYS = [
    { value: "name",      label: "Name" },
    { value: "patientId", label: "Patient ID" },
    { value: "phone",     label: "Phone" },
    { value: "dob",       label: "DOB" },
];

const PatientSearchForFileUpload = ({
    setSelectedTabOption,
    setIsNewUser,
    setSinglePatientInfo,
    singlePatientInfo,
    selectedTabOption,
    buttonName,
    isNewUser,
}) => {
    const dispatch = useDispatch();
    let { isLoading, allPatients, noPatientFound } = useSelector(
        (state) => state.patient
    );
    const { user } = useSelector((state) => state.auth);
    const [key, setKey] = useState("name")
    const [inputValue, setInputValue] = useState()
    const ref = useRef()
    const showPatientFun = (value) => {

        if (value?.length >= 1)
            dispatch(getPatients({ search: value?.trim(), key: key, doctorId: user?.user?._id }));
        else if (value?.length < 1) {
            dispatch(resetAllPatients());
            setSinglePatientInfo({});
            setIsNewUser(true);
        }
    };

    const setKeyFun = (value) => {
        setInputValue("")
        setKey(value)
    }

    useMemo(() => {
        if (isNewUser) {
            if (document.getElementById("patient-search"))
                document.getElementById("patient-search").value = "";
            dispatch(resetAllPatients());
        }
    }, [isNewUser]);

    const handleKeyDown = (event) => {
        if ((event.key == "Enter" && ref?.current.className == "patient-search-section")) {
            event.preventDefault();
            showPatientFun(inputValue)
        }
    }
    useEffect(() => {
        if (inputValue)
            document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [inputValue]);

    return (
        <div className="patient-search-section" ref={ref}>
            <div className="ps-search-box">
                <p className="ps-search-box__heading">Find Patient</p>

                <div className="ps-search-box__filters">
                    <span className="ps-search-box__filter-label">Search by</span>
                    <div className="ps-filter-pills">
                        {SEARCH_KEYS.map((opt) => (
                            <button
                                key={opt.value}
                                type="button"
                                className={`ps-filter-pill${key === opt.value ? " ps-filter-pill--active" : ""}`}
                                onClick={() => setKeyFun(opt.value)}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="ps-search-box__input-row">
                    <input
                        id="patient-search"
                        className="ps-search-box__input"
                        type={key === "dob" ? "date" : "text"}
                        placeholder={`Search by ${SEARCH_KEYS.find(o => o.value === key)?.label ?? key}…`}
                        autoComplete="off"
                        value={inputValue || ""}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                    <button
                        type="button"
                        className="ps-search-box__btn"
                        onClick={() => showPatientFun(inputValue)}
                    >
                        Search
                    </button>
                </div>
            </div>
            <div className="ps-patient-grid">
                {allPatients?.length > 0 && !isLoading &&
                    allPatients.map((patient, index) => (
                        <div
                            key={index}
                            className={`ps-patient-card${patient?._id === singlePatientInfo?._id ? " ps-patient-card--active" : ""}`}
                            onClick={() => {
                                setIsNewUser(false);
                                setSinglePatientInfo(patient);
                            }}
                        >
                            <div className="ps-patient-card__avatar">
                                {patient?.name?.trim()?.charAt(0)?.toUpperCase() || "?"}
                            </div>
                            <p className="ps-patient-card__name">{patient?.name}</p>
                            <div className="ps-patient-card__row">
                                <span className="ps-patient-card__label">ID</span>
                                <span className="ps-patient-card__value">{patient?.patientId}</span>
                            </div>
                            <div className="ps-patient-card__row">
                                <span className="ps-patient-card__label">Phone</span>
                                <span className="ps-patient-card__value">{patient?.phone || "—"}</span>
                            </div>
                            <div className="ps-patient-card__row">
                                <span className="ps-patient-card__label">DOB</span>
                                <span className="ps-patient-card__value">{dateFormat(patient?.dob?.slice(0, 10))}</span>
                            </div>
                        </div>
                    ))}

                {allPatients?.length === 0 && noPatientFound && !isLoading && (
                    <p className="no-patient-found">No patient found</p>
                )}
            </div>
        </div>
    );
};

export default PatientSearchForFileUpload;
